<div class="container wp-section">

    <div class="row row-cols-1 row-cols-md-2 g-3">

        @for (notifRec of notificationList; track notifRec) {

            <div class="col">
                <div class="card wp-card h-100">
                    <div class="card-body">
                        <h5 class="card-title">
                            <span class="badge">{{notifRec.messageSeqNum}}</span><br/>
                            <!-- {{isValidTimestamp(notifRec.messageHeader) ? notifRec.messageHeader : convertUTCToEDT(notifRec.createDate)}} -->
                        </h5>

                        @if (!isValidTimestamp(notifRec.messageHeader)) {
                            <p class="card-text text-break mb-2">
                                {{isValidTimestamp(notifRec.messageHeader) ? notifRec.messageHeader : convertUTCToEDT(notifRec.createDate)}}
                                <!-- {{notifRec.messageHeader}} -->
                            </p>
                        }

                        <p class="card-text text-break mb-2">{{notifRec.messageText}}</p>

                        @if (notifRec.linkUrl) {
                            <p class="card-text text-break mb-0">{{notifRec.linkUrl}}</p>
                        }
                    </div>
                </div>
            </div>

        } @empty {
        }

    </div>

    <div class="row">
        <div class="col-6 text-center">
            <button type="button" icon="fa fa-close" class="wp-btn wp-btn-cancel" (click)="onClose()" label="Close">Cancel</button>
        </div>
    </div>                


</div>

    
